import { Stack, Typography, Radio, useTheme, Paper, RadioGroup, FormControlLabel, FormControlUnstyled } from '@material-ui/core';
import { CrmType } from '../../../@types/firestore';

import { doc, updateDoc } from 'firebase/firestore';
import useAuth from 'hooks/useAuth';
import { useState, type ChangeEvent, type Dispatch, type SetStateAction, useEffect } from 'react';
import { usersCollection } from 'utils/firestoreConverters';
import useFirestore from 'hooks/useFirestore';
import { FormControl } from '@material-ui/core';
import { useTranslation } from 'react-i18next';


type RealEstateRoleInputProps = {
  onboarding?: boolean;
  onLoadingChange: Dispatch<SetStateAction<boolean>>;
  fireSnackbarOpen?: (message?: string) => void;
  setCanMoveToNextStep?: Dispatch<SetStateAction<boolean>>;
};

export function RealEstateRoleInput({ onboarding, onLoadingChange, fireSnackbarOpen, setCanMoveToNextStep }: RealEstateRoleInputProps) {
  const {user} = useAuth();
  const { userSettings } = useFirestore();
  const theme = useTheme();
  const {t} = useTranslation();
  const [pickedRealEstateRole, setPickedRealEstateRole] = useState<string>(userSettings?.realEstateRole ?? null);

  useEffect(() => {
    if(pickedRealEstateRole !== userSettings?.realEstateRole) {
      setPickedRealEstateRole(userSettings?.realEstateRole);
    }
  }
  , [userSettings?.realEstateRole]);
  
  useEffect(() => {
    if (pickedRealEstateRole) {
      setCanMoveToNextStep?.(true);
    } else {
      setCanMoveToNextStep?.(false);
    }
  }, [pickedRealEstateRole]);

  const handleRadioChange = async ({ target: { value, checked } }: ChangeEvent<HTMLInputElement>) => {
    const updatedRole = value;

    updateOnboardingMetadata(updatedRole);
  };

  const updateOnboardingMetadata = async (realEstateRole: string) => {
    setPickedRealEstateRole(realEstateRole);
    onLoadingChange?.(true);
    await updateDoc(doc(usersCollection, user?.email), {
      realEstateRole
    });
    onLoadingChange?.(false);
    fireSnackbarOpen?.('Profile updated');
  };

  const userRolesInputChoices: {
    value: string;
    label: string;
    sublabel: string;
  }[] = [
    {
      value: t("onboarding.realEstateRoleInput.singleRealtor"),
      label: t("onboarding.realEstateRoleInput.singleRealtor"),
      sublabel: ''
    },
    {
      value:  t("onboarding.realEstateRoleInput.realtorInAgency"),
      label:  t("onboarding.realEstateRoleInput.realtorInAgency"),
      sublabel: ''
    },
    {
      value:  t("onboarding.realEstateRoleInput.agencyManager"),
      label:  t("onboarding.realEstateRoleInput.agencyManager"),
      sublabel: ''
    },
    {
      value:  t("onboarding.realEstateRoleInput.other"),
      label:  t("onboarding.realEstateRoleInput.other"),
      sublabel: ''
    }
  ];

  return (
    <Stack gap={1}>
      {onboarding && (
        <Typography variant='body1' fontWeight='bold' sx={{ pt: 4 }}>
          {t("onboarding.realEstateRoleInput.title")}
        </Typography>
      )}

      <RadioGroup
    aria-labelledby="demo-radio-buttons-group-label"
    aria-required={true}
    name="radio-buttons-group"
    value={pickedRealEstateRole}
    onChange={handleRadioChange}
  >      <Stack direction='column' spacing={2.5} sx={{ pt: 2 }}>

        {userRolesInputChoices.map((choice) => (
          <Paper
            key={choice.value}
            variant='outlined'
            onClick={() => updateOnboardingMetadata(choice.value)}
            style={{ cursor: 'pointer' }}
            sx={{
              p: 2,
              borderColor: pickedRealEstateRole === choice.value ? theme.palette.grey[800] : theme.palette.grey[300],
              backgroundColor: pickedRealEstateRole === choice.value ? theme.palette.grey[50] : theme.palette.common.white
            }}
          >
            <Stack direction='row' alignItems={'center'}>
              <Radio  value={choice.value} />
              <Stack direction='column' spacing={0}>
                <Typography variant='subtitle1'>{choice.label}</Typography>
                <Typography variant='body2' color={theme.palette.grey[500]}>
                  {choice.sublabel}
                </Typography>
              </Stack>
            </Stack>
          </Paper>
        ))}
               </Stack>

        </RadioGroup>
    </Stack>
  );
}
